<template>
    <b-button-toolbar aria-label="Dropdown menu with relations">
        <b-link
            v-if="relations.length === 1"
            @click.stop="$_openRelation(relations[0])"
        >
            <span>{{ relations[0].name }}</span>
        </b-link>
        <b-dropdown
            v-else
            class="mx-1"
            dropleft
            toggle-tag="a"
            toggle-class="relations-dropdown"
            @show="$_showDropDown"
        >
            <template #button-content>
                <div class="edit-icon relations-icon"></div>
            </template>
            <b-dropdown-item
                v-for="relation in relations"
                :key="relation.relationId"
                @click="$_openRelation(relation)"
                :title="`${$t('relations.showRelated')} ${relation.name}`"
                >{{ relation.name }}</b-dropdown-item
            >
        </b-dropdown>
    </b-button-toolbar>
</template>

<script>
    import { mapState } from 'vuex';
    import { INTERFACE_PANEL_TRIGGERS } from '../../../../constants';

    export default {
        props: { relations: { type: Array, required: true } },
        computed: {
            ...mapState(['uiElements']),
            informationPanel() {
                return this.uiElements[INTERFACE_PANEL_TRIGGERS.INFORMATION];
            }
        },
        methods: {
            $_openRelation(relation) {
                this.$emit('openRelation', relation);
            },
            $_showDropDown(event) {
                const relationsLength = this.relations.length;
                const itemHeight = 28;
                const extraMargin = 150;
                const dropDownHeight = relationsLength * itemHeight + 10;
                const infoPanelHeight = this.informationPanel.height - extraMargin;
                if (dropDownHeight >= infoPanelHeight) {
                    this.$store.commit('UPDATE_INFORMATION_PANEL', {
                        height: dropDownHeight + extraMargin,
                        width: this.informationPanel.width,
                        maxWidth: this.informationPanel.maxWidth
                    });
                }
            }
        }
    };
</script>

<style lang="scss">
.relations-dropdown {
    padding: 0;
    border: 0 !important;
    display: flex;
    align-content: center;
    align-items: center;
    background-color: unset;

    .show > & {
        color: black !important;
        background-color: unset !important;
    }

    &:focus {
        box-shadow: none !important;
        background-color: unset;
    }

    &:hover {
        background-color: unset;
    }

    &:before {
        color: black !important;
    }
}
</style>

<style lang="scss" scoped>
.edit-icon {
    background-color: $blue-05;
}

.relations-icon {
    display: inline-block;
}
</style>
